// @ts-nocheck
import {
    chain,
    PopulateApiParameter,
    SendDataToApi,
} from "@insite/client-framework/Store/Pages/Cart/Handlers/AddToCart";
import { addProductWithResult } from "@store/Extensions/Services/CartService";
import { addToChainAfter, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";
import cloneDeep from "lodash/cloneDeep";

/**
 * We inject embroideries configuration if applicable
 */
addToChainAfter(chain, PopulateApiParameter, props => {
    const productDetail = props.getState().pages.productDetails;
    const configurationEmbroideries = cloneDeep(productDetail.configurationEmbroideries);

    if (!configurationEmbroideries || Object.keys(configurationEmbroideries).length <= 0) {
        return;
    }

    props.apiParameter.embroideries = configurationEmbroideries;
});

/**
 * This replaceInChain is used to override native addProductWithResult with store modified version
 */
replaceInChain(chain, SendDataToApi, async props => {
    const result = await addProductWithResult(props.apiParameter);
    if (result.successful) {
        props.apiResult = result.result;
    } else {
        if (result.statusCode === 403) {
            const { isAuthenticated, rememberMe } = props.getState().context.session;
            (isAuthenticated || rememberMe) && window.location.reload();
            return false;
        }

        props.parameter.onError?.(result.errorMessage);
        return false;
    }
});
